import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons'
import { Flex, Text } from '@chakra-ui/react'
import { AnimatedProgressBar } from './AnimatedProgressBar'
import { MotionFlex, itemVariants } from './animations'
import type { ChartDataItem } from './types'

interface OthersRowProps {
  company: ChartDataItem
  percentage: number
  label: string | number
  maxLabelLength: number
  isExpanded: boolean
  onToggleExpanded: () => void
  textColor: string
  selectedMetric: 'count' | 'totalValue'
}

export const OthersRow = ({
  company,
  percentage,
  label,
  maxLabelLength,
  isExpanded,
  onToggleExpanded,
  textColor,
  selectedMetric
}: OthersRowProps) => (
  <MotionFlex
    key="others"
    align="center"
    justify="space-between"
    gap={4}
    h='32px'
    variants={itemVariants}
    position={'relative'}
    cursor="pointer"
    onClick={onToggleExpanded}
    _hover={{ bg: 'gray.50' }}
    borderRadius="md"
    px={2}
    mx={-2}
  >
    <Flex align="center" w="56px" justify="center">
      {isExpanded ? (
        <ChevronUpIcon boxSize={6} color="primary.500" />
      ) : (
        <ChevronDownIcon boxSize={6} color="primary.500" />
      )}
    </Flex>
    <Flex align="center" flex={1} gap={3}
      flexGrow={1} justifyContent="space-between">
      {!isExpanded && (
        <>
          <AnimatedProgressBar percentage={percentage} bgColor={company.fill} metricKey={selectedMetric} />
          <Text
            fontSize="xs"
            color={textColor}
            fontWeight="medium"
            whiteSpace='nowrap'
            textAlign="right"
            w={`${maxLabelLength}ch`}
            zIndex={1}
          >
            {label}
          </Text>
        </>
      )}
      {isExpanded && (
        <Text
          fontSize="xs"
          color="gray.500"
          fontWeight="medium"
        >
          Skrýt ostatní
        </Text>
      )}
    </Flex>
  </MotionFlex>
)
